import {combineReducers} from 'redux';
import user from './user.reducer';
import loginReducer from './login.reducer';

const authReducers = combineReducers({
    user,
    loginReducer
});

export default authReducers;